import axios from 'axios'
import { API } from './url'

export default {
  getLive(success, error) {
    axios.get(API.downtime.live)
      .then(r => success(r.data))
      .catch(e => error((e.response && e.response.data && e.response.data.message) || 'Failed to load live data'))
  },

  getReports(filters, success, error) {
    axios.get(API.downtime.reports, { params: filters })
      .then(r => success(r.data))
      .catch(e => error((e.response && e.response.data && e.response.data.message) || 'Failed to load reports'))
  },

  saveEntry(form, success, error) {
    axios.post(API.downtime.entry, form)
      .then(r => success(r.data))
      .catch(e => error((e.response && e.response.data && e.response.data.message) || 'Failed to save entry'))
  },

  getRecentManual(success, error) {
    axios.get(API.downtime.recentManual)
      .then(r => success(r.data))
      .catch(e => error((e.response && e.response.data && e.response.data.message) || 'Failed to load entries'))
  },

  getSummary(success, error) {
    axios.get(API.downtime.summary)
      .then(r => success(r.data))
      .catch(e => error((e.response && e.response.data && e.response.data.message) || 'Failed to fetch monitoring data'))
  }
}
